module.exports = __webpack_public_path__ + "img/Fished.a4e79ccc.jpg";